@if (editingOptions().showMcqMetadata) {
  <dojo-number-input
    class="mb-4"
    [label]="'Total marks'"
    [formCtrl]="optionsFormGroup().controls.markscheme.controls.marks"
  />

  <div class="mb-4 border-b"></div>
}

<dojo-content-item-editor
  [contentItemsFormArray]="optionsFormGroup().controls.content_items"
  [editingOptions]="editingOptions()"
  [canAddRemoveText]="allowQuestionStructureEditing()"
  [canAddRemoveImage]="allowQuestionStructureEditing()"
  [canReorder]="allowQuestionStructureEditing()"
  [title]="'Options Item'"
  (editItem)="editOptionSubItem($event)"
/>

<div class="start flex items-center gap-2 pt-6">
  <div class="text-md text-primary font-semibold">Options</div>
  @if (editingOptions().allowMcqStructureEditing ?? false) {
    <div class="flex items-center py-4">
      <dojo-button [fill]="'outline'" [customColor]="'sky'" (click)="addOption()" [size]="'xs'">Add option</dojo-button>
    </div>
  }
</div>
<div class="options-container pt-2">
  @for (option of optionsFormGroup().controls.options.controls; track $index) {
    <div class="option-item not-first:border-t not-first:border-neutral-100 flex items-start gap-1 py-1">
      <dojo-option-label class="mt-1" [index]="$index" />
      <mat-radio-button
        class="mt-1"
        [checked]="state.correctOptionIndexesValue[0] === $index"
        (change)="toggleCorrectOption($index)"
        [matTooltip]="'Set as correct option'"
        [disabled]="!editingOptions().allowMcqEditing || !(editingOptions().allowMcqStructureEditing ?? false)"
        color="primary"
      />

      <div class="flex-1">
        <dojo-content-item-editor
          [contentItemsFormArray]="option.controls.content_items"
          [editingOptions]="editingOptions()"
          [canAddRemoveText]="editingOptions().allowMcqStructureEditing ?? false"
          [canAddRemoveImage]="editingOptions().allowMcqStructureEditing ?? false"
          [canReorder]="editingOptions().allowMcqStructureEditing ?? false"
          [title]="'Option ' + ($index + 1)"
          (editItem)="editOptionSubItem($event, $index)"
        />
      </div>

      @if (editingOptions().allowMcqStructureEditing ?? false) {
        <dojo-icon-button
          [icon]="'trash-can'"
          (click)="removeOption($index)"
          [matTooltip]="'Delete option' + ($index + 1)"
        />
      }
    </div>
  }
</div>

@if (optionsFormGroup().controls.markscheme.controls.worked_solution; as workedSolutionFormArray) {
  <div class="worked-solution-editor pt-6">
    <dojo-content-item-editor
      [contentItemsFormArray]="workedSolutionFormArray"
      [editingOptions]="editingOptions()"
      [allowTextEditingOverride]="editingOptions().allowMarkschemeEditing"
      [canAddRemoveText]="editingOptions().allowMcqStructureEditing ?? false"
      [canAddRemoveImage]="editingOptions().allowMcqStructureEditing ?? false"
      [canReorder]="editingOptions().allowMcqStructureEditing ?? false"
      [title]="'Worked Solution'"
      (editItem)="editWorkedSolutionItem($event)"
    />
  </div>
}
